import TagsReducer from "./reducer";
import WidgetReducer from "./reducer";

export const setSelectWidget = (payload) => (dispatch) => {
  dispatch(WidgetReducer.actions.setSelectWidget(payload));
};

export const updateWidgetList = (payload) => (dispatch) => {
  dispatch(WidgetReducer.actions.updateWidgetList(payload));
};

export const clearSelectedWidget = () => (dispatch) => {
  dispatch(WidgetReducer.actions.clearSelectItems());
};

export const setWidgetList = (payload) => (dispatch) => {
  dispatch(WidgetReducer.actions.setWidgetList(payload));
};

export const setWidgetNewsList = (payload) => (dispatch) => {
  dispatch(WidgetReducer.actions.setWidgetNewsList(payload));
};

// export const addTagToList = (payload) => (dispatch) => {
//   dispatch(TagsReducer.actions.addList(payload));
// };

// export const openCreateTagModal = () => (dispatch) => {
//   dispatch(TagsReducer.actions.openCreateTagModal());
// };

// export const openSelectTagsModal = () => (dispatch) => {
//   dispatch(TagsReducer.actions.openSelectTagsModal());
// };

// export const setSelectedTags = (payload) => (dispatch) => {
//   dispatch(TagsReducer.actions.setSelectedTags(payload));
// };

// export const closeCreateTagModal = (payload) => (dispatch) => {
//   dispatch(TagsReducer.actions.closeCreateTagModal(payload));
// };

// export const closeSelectTagsModal = () => (dispatch) => {
//   dispatch(TagsReducer.actions.closeSelectTagsModal());
// };

// export const clearNewTag = () => (dispatch) => {
//   dispatch(TagsReducer.actions.clearNewTag());
// };
